<div class="aca-admin aca-mg">
  <aca-page-header [bare]="embedded" icon="settings" [title]="'DMS.MANAGE.TITLE' | translate" [subtitle]="'DMS.MANAGE.SUBTITLE' | translate">
    <button type="button" class="aca-mg__primary" (click)="create()"><mat-icon>add</mat-icon>{{ 'DMS.MANAGE.CREATE' | translate }}</button>
  </aca-page-header>

  <!-- KPI strip -->
  <div class="aca-mg__kpis">
    <div class="aca-mg__kpi">
      <span class="aca-mg__kpiicon aca-mg__kpiicon--blue"><mat-icon>account_tree</mat-icon></span>
      <span class="aca-mg__kpitext">
        <span class="aca-mg__kpilabel">{{ 'DMS.MANAGE.K_TOTAL' | translate }}</span>
        <span class="aca-mg__kpivalue">{{ kpi().total }}</span>
      </span>
    </div>
    <div class="aca-mg__kpi">
      <span class="aca-mg__kpiicon aca-mg__kpiicon--green"><mat-icon>check_circle</mat-icon></span>
      <span class="aca-mg__kpitext">
        <span class="aca-mg__kpilabel">{{ 'DMS.MANAGE.K_ACTIVE' | translate }}</span>
        <span class="aca-mg__kpivalue">{{ kpi().active }}</span>
      </span>
    </div>
    <div class="aca-mg__kpi">
      <span class="aca-mg__kpiicon aca-mg__kpiicon--gray"><mat-icon>edit_note</mat-icon></span>
      <span class="aca-mg__kpitext">
        <span class="aca-mg__kpilabel">{{ 'DMS.MANAGE.K_DRAFT' | translate }}</span>
        <span class="aca-mg__kpivalue">{{ kpi().draft }}</span>
      </span>
    </div>
    <div class="aca-mg__kpi">
      <span class="aca-mg__kpiicon aca-mg__kpiicon--purple"><mat-icon>autorenew</mat-icon></span>
      <span class="aca-mg__kpitext">
        <span class="aca-mg__kpilabel">{{ 'DMS.MANAGE.K_RUNNING' | translate }}</span>
        <span class="aca-mg__kpivalue">{{ kpi().running }}</span>
      </span>
    </div>
    <div class="aca-mg__kpi">
      <span class="aca-mg__kpiicon aca-mg__kpiicon--red"><mat-icon>error_outline</mat-icon></span>
      <span class="aca-mg__kpitext">
        <span class="aca-mg__kpilabel">{{ 'DMS.MANAGE.K_ERROR' | translate }}</span>
        <span class="aca-mg__kpivalue">{{ kpi().error }}</span>
      </span>
    </div>
  </div>

  <!-- filters -->
  <div class="aca-mg__filters">
    <label class="aca-mg__search">
      <mat-icon>search</mat-icon>
      <input type="search" [(ngModel)]="search" [placeholder]="'DMS.MANAGE.SEARCH' | translate" />
    </label>
    <select class="aca-mg__select" [(ngModel)]="filterCategory">
      <option value="">{{ 'DMS.MANAGE.F_CATEGORY' | translate }}</option>
      <option *ngFor="let c of categories()" [value]="c">{{ c }}</option>
    </select>
    <select class="aca-mg__select" [(ngModel)]="filterStatus">
      <option value="">{{ 'DMS.MANAGE.F_STATUS' | translate }}</option>
      <option value="active">{{ 'DMS.MANAGE.S_ACTIVE' | translate }}</option>
      <option value="draft">{{ 'DMS.MANAGE.S_DRAFT' | translate }}</option>
      <option value="disabled">{{ 'DMS.MANAGE.S_DISABLED' | translate }}</option>
    </select>
  </div>

  <mat-progress-bar mode="indeterminate" *ngIf="loading()" />

  <aca-page-state
    *ngIf="!loading() && !visible().length"
    state="empty"
    icon="account_tree"
    [title]="'DMS.MANAGE.EMPTY_TITLE' | translate"
    [message]="'DMS.MANAGE.EMPTY_HINT' | translate"
  />

  <section class="aca-mg__card" *ngIf="visible().length">
    <table class="aca-mg__table">
      <thead>
        <tr>
          <th>{{ 'DMS.MANAGE.COL_NAME' | translate }}</th>
          <th>{{ 'DMS.MANAGE.COL_CATEGORY' | translate }}</th>
          <th>{{ 'DMS.MANAGE.COL_VERSION' | translate }}</th>
          <th>{{ 'DMS.MANAGE.COL_STATUS' | translate }}</th>
          <th>{{ 'DMS.MANAGE.COL_INSTANCES' | translate }}</th>
          <th>{{ 'DMS.MANAGE.COL_MODIFIED' | translate }}</th>
          <th class="aca-mg__col-actions">{{ 'DMS.MANAGE.COL_ACTIONS' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let r of visible()">
          <td>
            <span class="aca-mg__name">
              <mat-icon class="aca-mg__nameicon">{{ r.kind === 'template' ? 'account_tree' : 'engineering' }}</mat-icon>
              {{ r.name }}
              <mat-icon *ngIf="r.template?.restricted" class="aca-mg__lock" [matTooltip]="'DMS.MANAGE.RESTRICTED' | translate"
                >visibility_lock</mat-icon
              >
            </span>
          </td>
          <td>
            <span class="aca-mg__chip aca-mg__chip--cat">{{ r.category }}</span>
          </td>
          <td>v{{ r.version }}</td>
          <td>
            <span class="aca-mg__chip" [ngClass]="'aca-mg__chip--' + r.status">{{ 'DMS.MANAGE.S_' + r.status.toUpperCase() | translate }}</span>
            <mat-icon *ngIf="r.instances > 0" class="aca-mg__warn" [matTooltip]="'DMS.MANAGE.HAS_INSTANCES' | translate">lock</mat-icon>
          </td>
          <td>{{ r.instances }}</td>
          <td>{{ (r.updatedAt | acaDate: 'd MMM y') || '—' }}</td>
          <td class="aca-mg__col-actions">
            <ng-container *ngIf="r.kind === 'template'; else engineNote">
              <button
                mat-icon-button
                type="button"
                [matTooltip]="'DMS.MANAGE.VIS_EDIT' | translate"
                [attr.aria-label]="'DMS.MANAGE.VIS_EDIT' | translate"
                (click)="visibility(r)"
              >
                <mat-icon>{{ r.template?.restricted ? 'visibility_lock' : 'visibility' }}</mat-icon>
              </button>
              <button
                mat-icon-button
                type="button"
                [matTooltip]="'DMS.MANAGE.EDIT' | translate"
                [attr.aria-label]="'DMS.MANAGE.EDIT' | translate"
                (click)="edit(r)"
              >
                <mat-icon>edit</mat-icon>
              </button>
              <button
                mat-icon-button
                type="button"
                [matTooltip]="'DMS.MANAGE.DUPLICATE' | translate"
                [attr.aria-label]="'DMS.MANAGE.DUPLICATE' | translate"
                (click)="duplicate(r)"
              >
                <mat-icon>content_copy</mat-icon>
              </button>
              <button
                mat-icon-button
                type="button"
                [matTooltip]="(r.status === 'disabled' ? 'DMS.MANAGE.ENABLE' : 'DMS.MANAGE.DISABLE') | translate"
                [attr.aria-label]="(r.status === 'disabled' ? 'DMS.MANAGE.ENABLE' : 'DMS.MANAGE.DISABLE') | translate"
                (click)="toggle(r)"
              >
                <mat-icon>{{ r.status === 'disabled' ? 'toggle_on' : 'toggle_off' }}</mat-icon>
              </button>
              <button
                mat-icon-button
                type="button"
                [matTooltip]="'DMS.MANAGE.DELETE' | translate"
                [attr.aria-label]="'DMS.MANAGE.DELETE' | translate"
                [disabled]="r.instances > 0"
                (click)="remove(r)"
              >
                <mat-icon>delete_outline</mat-icon>
              </button>
            </ng-container>
            <ng-template #engineNote>
              <span class="aca-mg__engine">{{ 'DMS.MANAGE.SYSTEM' | translate }}</span>
            </ng-template>
          </td>
        </tr>
      </tbody>
    </table>
  </section>
</div>
